import React, { useState, useEffect } from 'react';
import brokenPlaces from '../../assets/images/brokenPlaces.webp'

const Explore = ({ image }) => {
    const [currentImage, setCurrentImage] = useState(image);
    const [isLoading, setIsLoading] = useState(true);

    const checkImage = (url) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
            img.src = url;
        });
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const isImageCorrect = await checkImage(currentImage);
            if (!isImageCorrect) {
                setCurrentImage(brokenPlaces);
            }
            setIsLoading(false);
        })()
    }, [])



    return (
        <div>
            {!isLoading && <img className="explore-single-image" src={currentImage} alt="image" />}
        </div>
    )
}

export default Explore;